import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

const FloatingButtons = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Merhaba, halı yıkama hizmeti hakkında bilgi almak istiyorum.');
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${message}`, '_blank');
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${companyInfo.phones[0]}`;
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* Phone Button */}
      <button
        onClick={handlePhoneClick}
        className="w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110"
        aria-label="Telefon ile ara"
      >
        <Phone className="w-7 h-7" />
      </button>
      
      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110"
        aria-label="WhatsApp ile iletişime geç"
      >
        <MessageCircle className="w-7 h-7" />
      </button>
    </div>
  );
};

export default FloatingButtons;
